import { Component, JSX, SVGProps } from 'react';
export default class JapanIcon extends Component<SVGProps<SVGSVGElement>>
{
    public render(): JSX.Element
    {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" id="flag-icons-jp" viewBox="0 0 640 480" {...this.props}>
                <defs>
                    <clipPath id="a">
                        <path fill-opacity=".7" d="M-88 32h640v480H-88z" />
                    </clipPath>
                </defs>
                <g fill-rule="evenodd" stroke-width="1pt" clip-path="url(#a)" transform="translate(88 -32)">
                    <path fill="#fff" d="M-128 32h720v480h-720z" />
                    <circle cx="523.1" cy="344.1" r="194.9" fill="#d30000" transform="translate(-168.4 8.6) scale(.76554)" />
                </g>
            </svg>
        );
    }
};
